import { render, staticRenderFns } from "./EntWorkflowWelcome.vue?vue&type=template&id=43118594"
import script from "./EntWorkflowWelcome.vue?vue&type=script&setup=true&lang=js"
export * from "./EntWorkflowWelcome.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../cortex/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports